import React, { useEffect, useState } from "react";
import { ContactInfo, MedicineInfo, LoginInfo } from "./Utils/IvfLabelInput";
// import { RiErrorWarningLine } from "react-icons/ri";
// import Subscription from "./Subscription";
import Button from "@mui/material/Button";
// import { useGetSubscriptionsQuery } from "../../../Service/subscription";
// import {
//   useAddHospitalMutation,
//   useAddMerchantSubscriptionMutation,
//   useGetTransactionHistoryQuery,
//   useUpdateHospitalMutation,
// } from "../../../Service/hospitals";
import {
  validate,
  validateEmail,
  validatePassword,
  validatePhone,
} from "../../../utils";
import Toast from "../../../Component/DigitalMarketing/Toast";
import ImageSelectors from "../../../Component/DigitalMarketing/ImageSelectors";
import PermissionCheck from "../../../Component/PermissionCheck";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import AntSwitch from "../../../Component/DigitalMarketing/AntSwitch";
import {
  useAddMedicineMasterMutation,
  useUpdateMedicineMasterMutation,
} from "../../../Service/MedicineMaster";
import { useGetAllBranchesQuery } from "../../../Service/Masters";
import { useSelector } from "react-redux";
import BackdropLoader from "../../../Component/DigitalMarketing/BackDropLoader";

function MedicineDetails(props) {
  //   const { data: subscription } = useGetSubscriptionsQuery();
  const [selectedSub, setSelectedSub] = useState({});
  const [medicine, setMedicine] = useState(props.medicine);
  const [updated, setUpdated] = useState(props.updated);
  const [created, setCreated] = useState(props.created);
  const [hospitalImage, setMedicineImage] = useState(true);
  const account = useSelector((state: any) => state.auth);
  const { roleName } = account;
  const [submit, setSubmit] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [addmedicine, { isLoading: addLoading }] =
    useAddMedicineMasterMutation();
  const [updateMedicine, { isLoading: updateLoading }] =
    useUpdateMedicineMasterMutation();
  const { open, message, openSnackBar, type } = useSnackbar();

  //   const [addMerchantSubscription] = useAddMerchantSubscriptionMutation();

  const { data } = useGetAllBranchesQuery<any>({
    refetchOnMountOrArgChange: true,
  });

  console.log(props.medicin, "props.medicinee");
  useEffect(() => {
    setMedicine(props.medicine);
    setUpdated(props.updated);
    setCreated(props.created);
  }, [props]);

  const handleChangeInfo = (event, check = false) => {
    setSubmit(false);

    const { name, value } = event.target;

    setMedicine((prev) => {
      return { ...prev, [name]: value };
    });
    // console.log(medicine);
  };
  function openSnackBarerror(value) {
    openSnackBar(value, "error");
  }
  function isImageFile(value: any): boolean {
    return value instanceof File && value.type.startsWith("image/");
  }
  useEffect(() => {
    console.log(medicine);
  }, [handleChangeInfo]);

  const onSave = async () => {
    console.log(medicine, "medicinemedicinemedicine");
    setSubmit(true);
    const data = {
      ...medicine,
    };
    // console.log(data);

    if (
      validate(medicine.medicineName) &&
      validate(medicine.medicineType) &&
      validate(medicine.medicineDose) &&
      validate(medicine.manufacturing) &&
       validate(medicine.count)
    ) {
      // console.log("entered");

      if (!medicine.id) {
        try {
          const payload = await addmedicine({ ...data }).unwrap();
          // console.log("fulfilled", payload);

          props.setCreated(true);

          props.setshow(false);
        } catch (error: any) {
          // console.error("rejected", error);
          // openSnackBar(error?.data.message, "error");
          if (error?.status === 400) {
            openSnackBar(error?.data?.error, "error");
          }
        }
      } else {
        var {
          branchId,
          medicineType,
          medicineName,
          medicineDose,
          manufacturing,
          count,
        } = data;
        // console.log(activeStatus);
        // Create a new object with only the desired fields
        const extractedData = {
          medicineType,
          medicineName,
          medicineDose,
          manufacturing,
          count,
          branchId,
        };

        // console.log(extractedData);
        updateMedicine({
          id: medicine.id,
          ...extractedData,
        })
          .unwrap()
          .then((payload: any) => {
            if (payload?.error?.status === 400) {
              openSnackBar(payload?.error.data.message, "error");
            } else {
              props.setUpdated(true);
              props.setshow(false);
            }
          }) 
          .catch((error: any) => {
            // console.log("dsdsd", err);
            if (error?.status === 400) {
              openSnackBar(error?.data?.error, "error");
            }
          });
      }
    } else {
      openSnackBar("Fill required data", "error");
    }
  };
  return (
    <>
      <BackdropLoader loader={addLoading || updateLoading} />
      <Toast open={open} type={type} message={message} />

      <li className="d-flex">
        <div>
          <h6
            style={{
              fontSize: "18px",
              fontWeight: "700",
              lineHeight: "22px",
              letterSpacing: 0,
              textAlign: "left",
            }}
          >
            {medicine.id ? "Update medicine" : "Add new medicine"}
          </h6>
          <p
            style={{ fontSize: "18px", fontWeight: "500", lineHeight: "18px" }}
          >
            Medicine details
          </p>
        </div>
      </li>

      {MedicineInfo.map((a, i) => (
        <>
          <li
            className="input-custom"
            key={i}
            style={{ height: a.name == "description" ? "200px" : "" }}
          >
            <a.tag
              img={a.img}
              label={a.label}
              name={a.name}
              value={medicine[a.key]}
              handleChange={handleChangeInfo}
              validation={a.validation}
              keyName={a.key}
              submit={submit}
            />
          </li>
        </>
      ))}
      {roleName !== "branch" && (
        <div className="d-flex justify-content-between">
          <div>
            <span className="det-label">Branch</span>
          </div>
          <div>
            <select
              onChange={(event) => handleChangeInfo(event)}
              className="input-custom"
              placeholder="Select Branch"
              name="branchId"
              value={medicine.branchId}
            >
              <option value="">Select</option>
              {data?.data?.map((branch) => (
                <option key={branch.id} value={branch.id}>
                  {branch.branchName}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
      {/* <li className="input-custom">
        <>
          <span className="det-label">{"Status"}</span>
          <AntSwitch
            checked={medicine.activeStatus ==1 }
            onChange={(e) => handleChangeInfo(e, true)}
            name="activeStatus"
            inputProps={{ "aria-label": "ant design" }}
          />
        </>
      </li> */}
      {updated && (
        <div className="d-flex justify-content-center">
          {props.cancel}
          <Button
            variant="contained"
            disabled={updateLoading}
            onClick={onSave}
            id="btn-save"
          >
            {updateLoading ? "Wait" : "Update"} &#x2713;
          </Button>
        </div>
      )}
      <div className="d-flex justify-content-center mt-3">
        {props.cancel}
        <Button
          variant="contained"
          disabled={addLoading || updateLoading}
          onClick={onSave}
          id="btn-save"
        >
          {addLoading ? "Wait" : "Save"} &#x2713;
        </Button>
      </div>
    </>
  );
}

export default React.memo(MedicineDetails);
